import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../store/slices/authSlice"; // или deleteAuth

export function useLogout() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return () => {
        localStorage.clear();
        dispatch(logout()); // или dispatch(deleteAuth());
        navigate("/auth");
    };
}